import React from 'react';
import { createPortal } from 'react-dom';
import { format, parseISO } from 'date-fns';

const fmtDate = (v) => {
  if (!v) return '—';
  const d = typeof v === 'string' ? parseISO(v) : new Date(v);
  return Number.isNaN(d.getTime()) ? '—' : format(d, 'd MMM yyyy, HH:mm');
};

const WarehouseDetailsModal = ({ open, onClose, loading, error, data }) => {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const content = (
    <div
      className="fixed inset-0 flex items-center justify-center p-3 md:p-4"
      style={{ zIndex: 99999 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="warehouse-details-title"
    >
      <div className="absolute inset-0 bg-black/20" onClick={handleBackdropClick} aria-hidden="true" />
      <div
        className="relative w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col bg-white rounded-[18px] border border-[#EEF1F5] shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between shrink-0 px-6 pt-6 pb-2">
          <h2 id="warehouse-details-title" className="text-lg font-semibold text-[#101828]">
            Warehouse Details
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="w-7 h-7 rounded-full border border-[#D0D5DD] text-[#667085] flex items-center justify-center bg-white hover:bg-[#F6F7FA] transition"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <hr className="border-0 border-t border-[#EEF1F5] mt-2" />
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {loading && (
            <div className="py-8 text-center text-gray-500 text-sm">Loading...</div>
          )}
          {error && !loading && (
            <div className="py-8 text-center text-red-600 text-sm">{error}</div>
          )}
          {!loading && !error && data && (
            <div className="space-y-4 text-sm">
              <div><span className="text-gray-500">Name:</span> <span className="text-[#101828]">{data.name ?? '—'}</span></div>
              <div><span className="text-gray-500">Code:</span> <span className="text-[#101828]">{data.code ?? '—'}</span></div>
              <div><span className="text-gray-500">Status:</span> <span className="text-[#101828]">{data.isActive === true ? 'Active' : data.isActive === false ? 'Inactive' : '—'}</span></div>
              {data.city && (
                <>
                  <div><span className="text-gray-500">City:</span> <span className="text-[#101828]">{data.city.cityName ?? '—'}</span></div>
                  <div><span className="text-gray-500">State / Region:</span> <span className="text-[#101828]">{data.city.stateRegion ?? '—'}</span></div>
                  <div><span className="text-gray-500">Country:</span> <span className="text-[#101828]">{data.city.country ?? '—'}</span></div>
                  <div><span className="text-gray-500">City Status:</span> <span className="text-[#101828]">{data.city.status ?? '—'}</span></div>
                </>
              )}
              {!data.city && (
                <div><span className="text-gray-500">City:</span> <span className="text-[#101828]">—</span></div>
              )}
              {/* <div><span className="text-gray-500">Created:</span> <span className="text-[#101828]">{fmtDate(data.createdAt)}</span></div>
              <div><span className="text-gray-500">Updated:</span> <span className="text-[#101828]">{fmtDate(data.updatedAt)}</span></div> */}
            </div>
          )}
        </div>
        <div className="shrink-0 px-6 py-4 border-t border-[#EEF1F5] flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-[#D0D5DD] bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default WarehouseDetailsModal;
